<div class="container py-4">
	<!-- Header: title + generate button -->
	<div class="page-header">
		<h2>{{ 'cross-formation-report_common_name' | translate }}</h2>
		<button
			nz-button
			nzType="primary"
			nzSize="large"
			[nzLoading]="generating"
			[disabled]="!canPreview() || includedCount === 0 || previewLoading"
			(click)="generate()"
		>
			{{ 'cross-formation-report_generate-btn' | translate }}
		</button>
	</div>

	<!-- Filters -->
	<div class="filters-card">
		<div class="row">
			<div class="col-12 col-md-6 mb-3">
				<nz-form-label nzRequired>{{
					'cross-formation-report_report' | translate
				}}</nz-form-label>
				<nz-select
					[(ngModel)]="selectedReport"
					(ngModelChange)="onFiltersChange()"
					[nzPlaceHolder]="
						'cross-formation-report_report-placeholder' | translate
					"
					nzShowSearch
					nzServerSearch
					(nzOnSearch)="reportSearchChange$.next($event)"
					[nzLoading]="reportLoading"
					style="width: 100%"
				>
					<nz-option
						*ngFor="let o of reportOptions"
						[nzValue]="o.value"
						[nzLabel]="o.label"
					></nz-option>
				</nz-select>
			</div>

			<div class="col-12 col-md-6 mb-3">
				<nz-form-label nzRequired>{{
					'cross-formation-report_source-reports' | translate
				}}</nz-form-label>
				<nz-select
					[(ngModel)]="selectedSourceReports"
					(ngModelChange)="onFiltersChange()"
					[nzPlaceHolder]="
						'cross-formation-report_source-reports-placeholder'
							| translate
					"
					nzMode="multiple"
					nzShowSearch
					nzServerSearch
					[nzMaxTagCount]="0"
					[nzMaxTagPlaceholder]="sourceReportsTagPlaceholder"
					(nzOnSearch)="sourceReportSearchChange$.next($event)"
					[nzLoading]="sourceReportLoading"
					style="width: 100%"
				>
					<nz-option
						*ngFor="let o of sourceReportOptions"
						[nzValue]="o.value"
						[nzLabel]="o.label"
					></nz-option>
				</nz-select>
				<ng-template #sourceReportsTagPlaceholder let-selectedList>
					{{ selectedList.length }} rapport(s) sélectionné(s)
				</ng-template>
			</div>

			<div class="col-12 col-md-6 mb-3">
				<nz-form-label>{{
					'cross-formation-report_themes' | translate
				}}</nz-form-label>
				<nz-select
					[(ngModel)]="selectedThemes"
					(ngModelChange)="onFiltersChange()"
					[nzPlaceHolder]="
						'cross-formation-report_themes-placeholder' | translate
					"
					nzMode="multiple"
					nzShowSearch
					nzServerSearch
					nzAllowClear
					[nzMaxTagCount]="0"
					[nzMaxTagPlaceholder]="themesTagPlaceholder"
					(nzOnSearch)="themeSearchChange$.next($event)"
					[nzLoading]="themeLoading"
					style="width: 100%"
				>
					<nz-option
						*ngFor="let o of themeOptions"
						[nzValue]="o.value"
						[nzLabel]="o.label"
					></nz-option>
				</nz-select>
				<ng-template #themesTagPlaceholder let-selectedList>
					{{ selectedList.length }} thème(s) sélectionné(s)
				</ng-template>
			</div>

			<div class="col-12 col-md-6 mb-3">
				<nz-form-label>{{
					'cross-formation-report_formateur' | translate
				}}</nz-form-label>
				<nz-select
					[(ngModel)]="selectedFormateurs"
					(ngModelChange)="onFiltersChange()"
					[nzPlaceHolder]="
						'cross-formation-report_formateur-placeholder'
							| translate
					"
					nzMode="multiple"
					nzShowSearch
					nzServerSearch
					nzAllowClear
					[nzMaxTagCount]="0"
					[nzMaxTagPlaceholder]="formateursTagPlaceholder"
					(nzOnSearch)="formateurSearchChange$.next($event)"
					[nzLoading]="formateurLoading"
					style="width: 100%"
				>
					<nz-option
						*ngFor="let o of formateurOptions"
						[nzValue]="o.value"
						[nzLabel]="o.label"
					></nz-option>
				</nz-select>
				<ng-template #formateursTagPlaceholder let-selectedList>
					{{ selectedList.length }} formateur(s) sélectionné(s)
				</ng-template>
			</div>

			<div class="col-12 col-md-6 mb-3">
				<nz-form-label>{{
					'cross-formation-report_commanditaire' | translate
				}}</nz-form-label>
				<nz-select
					[(ngModel)]="selectedCommanditaires"
					(ngModelChange)="onFiltersChange()"
					[nzPlaceHolder]="
						'cross-formation-report_commanditaire-placeholder'
							| translate
					"
					nzMode="multiple"
					nzShowSearch
					nzServerSearch
					nzAllowClear
					[nzMaxTagCount]="0"
					[nzMaxTagPlaceholder]="commanditairesTagPlaceholder"
					(nzOnSearch)="commanditaireSearchChange$.next($event)"
					[nzLoading]="commanditaireLoading"
					style="width: 100%"
				>
					<nz-option
						*ngFor="let o of commanditaireOptions"
						[nzValue]="o.value"
						[nzLabel]="o.label"
					></nz-option>
				</nz-select>
				<ng-template #commanditairesTagPlaceholder let-selectedList>
					{{ selectedList.length }} commanditaire(s) sélectionné(s)
				</ng-template>
			</div>

			<div class="col-12 col-md-6 mb-3">
				<nz-form-label>{{
					'cross-formation-report_date-range' | translate
				}}</nz-form-label>
				<nz-range-picker
					[(ngModel)]="dateRange"
					(ngModelChange)="onFiltersChange()"
					style="width: 100%"
				></nz-range-picker>
			</div>

			<div class="col-12 mb-2">
				<label nz-checkbox [(ngModel)]="withComments">
					{{ 'cross-formation-report_with-comments' | translate }}
				</label>
			</div>
		</div>
	</div>

	<!-- Empty state: not enough info to preview -->
	<div *ngIf="!canPreview()" class="empty-state">
		{{ 'cross-formation-report_empty-state' | translate }}
	</div>

	<!-- Sticky key indicators (always rendered while we have data, even during refresh) -->
	<div
		*ngIf="canPreview() && totals"
		class="totals-bar"
		[class.is-loading]="previewLoading"
	>
		<div class="totals-grid">
			<div class="total-item">
				<span class="total-value">{{ totals.formations_count }}</span>
				<span class="total-label">{{
					'cross-formation-report_formations-count' | translate
				}}</span>
			</div>
			<div class="total-item">
				<span class="total-value">{{ totals.rapports_count }}</span>
				<span class="total-label">{{
					'cross-formation-report_rapports-count' | translate
				}}</span>
			</div>
			<div class="total-item">
				<span class="total-value">{{ totals.respondants_count }}</span>
				<span class="total-label">{{
					'cross-formation-report_respondants-count' | translate
				}}</span>
			</div>
			<div class="total-item">
				<span class="total-value">{{ totals.formateurs_count }}</span>
				<span class="total-label">{{
					'cross-formation-report_formateurs-count' | translate
				}}</span>
			</div>
			<div
				class="total-item"
				*ngIf="previewResult && previewResult.date_range"
			>
				<span class="total-value">
					{{ formatDate(previewResult.date_range.start) }} →
					{{ formatDate(previewResult.date_range.end) }}
				</span>
				<span class="total-label">{{
					'cross-formation-report_date-range' | translate
				}}</span>
			</div>
		</div>

		<div class="surveys-mini">
			<div class="survey-mini" *ngFor="let s of totals.surveys">
				<span class="survey-mini-label">{{ s.label }}</span>
				<span class="survey-mini-counts">
					{{ s.results_count }} / {{ s.expected_count }}
					<span
						class="survey-mini-percent"
						*ngIf="s.expected_count > 0"
						>({{ s.percent }}%)</span
					>
				</span>
			</div>
		</div>

		<div class="loading-overlay" *ngIf="previewLoading">
			<i nz-icon nzType="loading" nzTheme="outline"></i>
		</div>
	</div>

	<!-- Initial loading (no data yet) -->
	<div
		*ngIf="canPreview() && previewLoading && !totals"
		class="initial-loading"
	>
		<i nz-icon nzType="loading" nzTheme="outline"></i>
		{{ 'cross-formation-report_loading' | translate }}
	</div>

	<!-- Verification list -->
	<div
		*ngIf="canPreview() && previewResult"
		class="verification-block"
		[class.is-loading]="previewLoading"
	>
		<div class="verification-header">
			<h4>{{ 'cross-formation-report_tree-formations' | translate }}</h4>
			<div class="verification-actions">
				<button
					nz-button
					nzSize="small"
					nzType="link"
					(click)="selectAll()"
					[disabled]="!hasExclusion"
				>
					{{ 'cross-formation-report_select-all' | translate }}
				</button>
				<button
					nz-button
					nzSize="small"
					nzType="link"
					(click)="deselectAll()"
					[disabled]="includedCount === 0"
				>
					{{ 'cross-formation-report_deselect-all' | translate }}
				</button>
				<span class="verification-meta" *ngIf="hasExclusion">
					<i nz-icon nzType="warning" nzTheme="outline"></i>
					{{ previewResult.formations.length - includedCount }}
					{{ 'cross-formation-report_excluded-warning' | translate }}
				</span>
			</div>
		</div>

		<div class="formation-tree">
			<div
				*ngFor="let f of previewResult.formations"
				class="formation-node"
				[class.deselected]="isExcluded(f._id)"
			>
				<div class="formation-header" (click)="toggleExpand(f._id)">
					<label
						nz-checkbox
						[ngModel]="!isExcluded(f._id)"
						(ngModelChange)="toggleFormation(f._id)"
						(click)="$event.stopPropagation()"
					></label>
					<i
						nz-icon
						[nzType]="isExpanded(f._id) ? 'down' : 'right'"
						class="expand-icon"
					></i>
					<span class="formation-name">{{ f.name }}</span>
					<span class="formation-meta">
						{{ f.thematiques_count }}
						{{
							'cross-formation-report_rapports-suffix' | translate
						}}
						&middot; {{ f.respondants_count }}
						{{
							'cross-formation-report_respondants-suffix'
								| translate
						}}
					</span>
					<span class="formation-dates" *ngIf="f.start_date">
						{{ formatDate(f.start_date)
						}}<span *ngIf="f.end_date">
							- {{ formatDate(f.end_date) }}</span
						>
					</span>
				</div>
				<div class="thematique-list" *ngIf="isExpanded(f._id)">
					<div *ngFor="let t of f.thematiques" class="thematique-row">
						<span class="thematique-name">{{ t.name }}</span>
						<span
							class="thematique-formateur"
							*ngIf="t.formateur_id"
						>
							<i nz-icon nzType="user" nzTheme="outline"></i>
							{{ formateurNameById(t.formateur_id) }}
						</span>
						<span class="thematique-dates" *ngIf="t.start_date">
							{{ formatDate(t.start_date)
							}}<span *ngIf="t.end_date">
								- {{ formatDate(t.end_date) }}</span
							>
						</span>
					</div>
				</div>
			</div>

			<div
				*ngIf="previewResult.formations.length === 0"
				class="empty-list"
			>
				{{ 'common_empty' | translate }}
			</div>
		</div>
	</div>
</div>
